import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ListSubheader from '@material-ui/core/ListSubheader';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import DraftsIcon from '@material-ui/icons/Drafts';
import SendIcon from '@material-ui/icons/Send';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import StarBorder from '@material-ui/icons/StarBorder';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import AddAlertIcon from '@material-ui/icons/AddAlert';
import Badge from '@material-ui/core/Badge';
import Chip from '@material-ui/core/Chip';

const styles = theme => ({
    root: {
        flexGrow: 1,
        width: '100%',
        backgroundColor: theme.palette.background.paper,
    },
    paper: {
        padding: theme.spacing.unit * 2,
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    paperContainer: theme.mixins.gutters({
        paddingTop: 16,
        paddingBottom: 16,
        marginTop: 0,
    }),
    nested: {
        paddingLeft: theme.spacing.unit * 4,
    },
    margin: {
        margin: theme.spacing.unit * 2,
    },
});

function handleClick() {
    alert('This will navigate to a page showing more details'); // eslint-disable-line no-alert
}

class JourneyStageInsightsResearch extends React.Component {
    state = { open: true };

    handleClick = () => {
        this.setState({ open: !this.state.open });
    };

    render() {
        const { classes } = this.props;

        return (
            <div className={classes.root}>
                <Grid container spacing={24}>
                    <Grid item xs={12}>
                        <List
                            component="nav"
                            subheader={<ListSubheader component="div">description of what Research stage is</ListSubheader>}
                        >
                            {/* {this.props.insights.map((insight, index) =>
                                <ListItem button>
                                    <ListItemIcon>
                                        <AddAlertIcon />
                                    </ListItemIcon>
                                    <ListItemText inset primary={insight.title} />
                                </ListItem>
                            )} */}
                            <ListItem button>
                                <ListItemIcon>
                                    <AddAlertIcon />
                                </ListItemIcon>
                                <Chip
                                    label="63%"
                                    onClick={handleClick}
                                    className={classes.chip}
                                />&nbsp;
                                of contacts converted on&nbsp;
                                <Chip
                                    label="Mobile channel"
                                    onClick={handleClick}
                                    className={classes.chip}
                                />
                            </ListItem>
                            <ListItem button>
                                <ListItemIcon>
                                    <AddAlertIcon />
                                </ListItemIcon>
                                <Chip
                                    label="2 common profile keys"
                                    onClick={handleClick}
                                    className={classes.chip}
                                />&nbsp;
                                found for contacts in this stage
                            </ListItem>
                            <ListItem button>
                                <ListItemIcon>
                                    <AddAlertIcon />
                                </ListItemIcon>
                                <Chip
                                    label="17%"
                                    onClick={handleClick}
                                    className={classes.chip}
                                />&nbsp;were exposed to&nbsp;<Chip
                                    label="Content Variant C"
                                    onClick={handleClick}
                                    className={classes.chip}
                                />
                            </ListItem>

                            <ListItem button>
                                <ListItemIcon>
                                    <AddAlertIcon />
                                </ListItemIcon>
                                <Chip
                                    label="123 contacts"
                                    onClick={handleClick}
                                    className={classes.chip}
                                />
                                &nbsp;are likely to convert to 'Customer' stage in next 2 weeks
                            </ListItem>
                            <ListItem button>
                                <ListItemIcon>
                                    <AddAlertIcon />
                                </ListItemIcon>
                                Average velocity is&nbsp;<Chip
                                    label="11 days"
                                    onClick={handleClick}
                                    className={classes.chip}
                                />
                            </ListItem>
                            {/* <ListItem button onClick={this.handleClick}>
                        <ListItemIcon>
                            <InboxIcon />
                        </ListItemIcon>
                        <ListItemText inset primary="Inbox" />
                        {this.state.open ? <ExpandLess /> : <ExpandMore />}
                    </ListItem>
                    <Collapse in={this.state.open} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                            <ListItem button className={classes.nested}>
                                <ListItemIcon>
                                    <StarBorder />
                                </ListItemIcon>
                                <ListItemText inset primary="Starred" />
                            </ListItem>
                        </List>
                    </Collapse> */}
                        </List>
                    </Grid>
                    {/* <Grid item xs={0}>
                        <Paper className={classes.paperContainer}>
                            <Typography component="p">
                                some description of the selected insight...
                            </Typography>
                        </Paper>
                    </Grid> */}
                </Grid>
            </div>
        );
    }
}

JourneyStageInsightsResearch.propTypes = {
    classes: PropTypes.object.isRequired,
    label: PropTypes.string.isRequired,
    insights: PropTypes.array.isRequired
};

JourneyStageInsightsResearch.defaultProps = {
    insights: [],
    label: "default insights label"
};

export default withStyles(styles)(JourneyStageInsightsResearch);




// WEBPACK FOOTER //
// ./src/components/JourneyStageInsightsResearch.js